import { useDispatch, useSelector } from 'react-redux';

import { setTutorialSeen } from '../../store/Reducers/settings';


// Los tutoriales se publican con el sitio: site/public/animaciones/tutoriales/<slug>.html.
// Con .html: el dev server de Astro solo sirve el archivo tal cual; Cloudflare lo redirige (307) a la URL limpia
const TUTORIALS_URL = 'https://ding-dong.mx/animaciones/tutoriales';

export function tutorialUrl(slug: string) {
  return `${TUTORIALS_URL}/${slug}.html`;
}


/** Si este dispositivo ya vio el tutorial (se guarda con redux-persist, no en la API). */
export function useTutorialSeen(slug: string): [boolean, () => void] {
  const dispatch = useDispatch();
  // ?. porque redux-persist reemplaza el slice completo: quien ya tenía settings guardado no trae tutorialsSeen
  const seen = useSelector((state: any) => !!state.settings?.tutorialsSeen?.[slug]);

  return [seen, () => dispatch(setTutorialSeen(slug))];
}
